import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-project-description-section gfu-project-description-section--emphasized" }
const _hoisted_2 = ["data-qa"]
const _hoisted_3 = { "format-key": "0" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_heading = _resolveComponent("base-heading")
  const _component_localize = _resolveComponent("localize")
  const _component_project_section_timeline_card = _resolveComponent("project-section-timeline-card")
  const _component_base_slider = _resolveComponent("base-slider")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: "anchor",
      class: "gfu-layout-wrapper gfu-layout-wrapper--extranarrow gfu-4of5--l gfu-3of5--xl",
      "data-qa": `project-description-section-title:${$props.header}`
    }, [
      _createVNode(_component_base_slider, {
        ref: "slider",
        mode: "slide",
        items: $options.sliderItems,
        "extra-large-screen-visible-items-count": 3,
        "slide-gap-classes": "_px-1",
        "scroll-container-wrapper-classes": "_pos-r _-mx-1",
        "navigation-wrapper-classes": "_as-fs _shrink-0",
        onScrollLeft: _cache[0] || (_cache[0] = $event => ($options.onScroll('left'))),
        onScrollRight: _cache[1] || (_cache[1] = $event => ($options.onScroll('right'))),
        onGetItems: $options.onGetItems
      }, {
        prefix: _withCtx(() => [
          _createVNode(_component_base_heading, {
            divider: "left",
            tag: "h2",
            class: "_mb-1"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.ProjectTimelineHeader), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_localize, {
            resource: _ctx.Resources.ProjectHome.ProjectTimelineProgressInfoMessage
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_3, [
                _createElementVNode("a", {
                  class: "gfu-link gfu-link--accent",
                  href: $options.helpUrl
                }, _toDisplayString(_ctx.Resources.ProjectHome.ProjectTimelineHelpLabel), 9 /* TEXT, PROPS */, _hoisted_4)
              ]),
              _createElementVNode("a", {
                "format-key": "1",
                class: "gfu-link gfu-link--accent",
                href: $options.crowdfundingGuideUrl
              }, _toDisplayString(_ctx.Resources.ProjectHome.ProjectTimelineCrowdfundingGuideLabel), 9 /* TEXT, PROPS */, _hoisted_5)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["resource"])
        ]),
        slide: _withCtx(({item}) => [
          _createVNode(_component_project_section_timeline_card, _normalizeProps(_guardReactiveProps(item)), null, 16 /* FULL_PROPS */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["items", "onGetItems"])
    ], 8 /* PROPS */, _hoisted_2)
  ]))
}